<!--
 * @Author: tony.zhu
 * @Date: 2025-09-26 10:55:34
 * @LastEditTime: 2025-12-26 15:54:55
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div class="ai-chat aiInterviewConsultantDialog">
    <Drawer :drawerVisible="drawerVisible" v-on="$listeners">
      <template slot="content" slot-scope="{ data }">
        <Chat
          v-if="drawerVisible"
          :apiBaseUrl="apiBaseUrl"
          :suggestQuestionsProp="suggestQuestions"
          v-on="$listeners"
          :interview="interview"
          :source="source"
        ></Chat>
      </template>
    </Drawer>
  </div>
</template>

<script>
import Drawer from "./components/drawer/index.vue";
import Chat from "./components/chat/index.vue";

export default {
  name: "AiChat",
  components: { 
    Drawer, 
    Chat 
  },
  props: {
    apiBaseUrl: {
      type: String,
      default: "https://preapiconsole.71360.com/api/app/personnel-assessment-enterprise/enterprise",
    },
    // 建议问题列表
    suggestQuestions: {
      type: Array,
      // required: true,
      default() {
        return [];
      },
    },
    interview: {
      type: Object,
      default() {
        return {}
      }
    },
    source: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      drawerVisible: true,
    };
  },
  methods: {
    onShow() {
      if (!this.drawerVisible) {
        this.$nextTick(() => {
          this.drawerVisible = true;
          const timer = setTimeout(() => {
            clearTimeout(timer);
          }, 0);
        });
      } else {
        this.drawerVisible = true;
        this.$nextTick(() => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
//@import "styles/index.scss";


</style>

<style lang="scss">
.custom_del_message {
  padding-bottom: 0 !important;
  border: 0 !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  // &.no-title {
  .el-message-box__header {
    padding: 0;
    height: 44px;
    border-bottom: 0 !important;

    .el-message-box__title {
      display: none;
    }

    .el-message-box__headerbtn {
      top: 30px;
      transform: translateY(-12px);
    }
  }

  .el-message-box__content {
    padding: 8px 24px 23px;

    .el-message-box__container {
      display: flex;
      align-items: center;

      .el-message-box__status {
        &.el-icon-warning {
          display: none;
        }
      }

      .el-message-box__message {
        padding-left: 0;
        p {
          .el-icon-warning {
            font-size: 24px;
            margin-right: 8px;
            color: rgb(255, 125, 0);
          }

          .num {
            color: #7657fb;
          }

          font-size: 14px;
          color: #1d2129;
          line-height: 22px;

          > div {
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }

  .el-message-box__btns {
    padding: 0 24px 24px;
    border-top: 0 !important;

    .el-button {
      height: 36px;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      line-height: 20px;
      padding: 7px 20px;

      &:first-child {
        background: #f2f3f5;
        border-color: #f2f3f5;

        > span {
          font-size: 14px;
          color: #4e5969;
          line-height: 22px;
        }
      }

      &:last-child {
        margin-left: 16px;
        background: #f53f3f;
        border-color: #f53f3f;
      }
    }
  }
  // }
}
</style>